import { render, staticRenderFns } from "./Person15.vue?vue&type=template&id=136b7e32&scoped=true&"
import script from "./Person15.vue?vue&type=script&lang=js&"
export * from "./Person15.vue?vue&type=script&lang=js&"
import style0 from "./Person15.vue?vue&type=style&index=0&id=136b7e32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136b7e32",
  null
  
)

export default component.exports